<mat-toolbar class="mat-primary">
    <h2>{{'library_editor.dialog.title_add_symbol' | translate}}</h2>
    <span class="spacer"></span>
    <button mat-icon-button (click)="dialogRef.close()">
        <mat-icon>close</mat-icon>
    </button>
</mat-toolbar>

<mat-dialog-content (keydown.enter)="submitByEnter()">
    <mat-form-field class="full-width">
        <input
            matInput
            placeholder="{{'library_editor.name' | translate}}"
            [(ngModel)]="data.name"
            name="name"
            maxlength="200"
            cdkFocusInitial
        />
    </mat-form-field>
</mat-dialog-content>

<mat-dialog-actions>
    <button mat-button (click)="onNoClick()">{{'library_editor.dialog.cancel' | translate}}</button>
    <button mat-button [mat-dialog-close]="data">{{'library_editor.dialog.apply' | translate}}</button>
</mat-dialog-actions>
